import { useState, useEffect } from "react";
import { getAllApplications } from "../../services/api";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token") || localStorage.getItem("adminToken");
const fmt = n => "KSh " + Number(n||0).toLocaleString("en-KE");

export default function Loans() {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("FEE_PAID");
  const [search, setSearch] = useState("");
  const [toast, setToast] = useState({ msg:"", type:"" });
  const [retrying, setRetrying] = useState({});
  const [disbursing, setDisbursing] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getAllApplications();
      setLoans(data.filter(a => a.selectedLoanAmount || a.loanStatus).sort((a,b)=>(b.id||0)-(a.id||0)));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const showToast = (msg, type="success") => { setToast({msg,type}); setTimeout(()=>setToast({msg:"",type:""}), 5000); };

  const disburse = async (app) => {
    const net = (app.selectedLoanAmount||0) - (app.loanFeeAmount||0);
    if (!window.confirm(`Send ${fmt(net)} via M-Pesa B2C to ${app.fullName} (${app.phone})?`)) return;
    setDisbursing(d=>({...d,[app.id]:true}));
    setErrors(e=>({...e,[app.id]:null}));
    try {
      const phone = (app.phone||"").startsWith("0") ? "254"+app.phone.substring(1) : app.phone;
      const r = await fetch(`${BASE}/mpesa/b2c`, {
        method:"POST",
        headers:{ Authorization:"Bearer "+tok(), "Content-Type":"application/json" },
        body: JSON.stringify({ phone, amount:net, remarks:`Loan disbursement APP-${app.id}`, commandId:"BusinessPayment", applicationId:app.id })
      });
      const data = await r.json();
      if (data.success || data.ResponseCode === "0") {
        showToast(`Disbursed ${fmt(net)} to ${app.fullName}!`);
        load();
      } else {
        const errMsg = data.message || data.errorMessage || data.ResponseDescription || "Disbursement failed";
        setErrors(e=>({...e,[app.id]:errMsg}));
        showToast("Disbursement failed: " + errMsg, "error");
      }
    } catch(e) {
      setErrors(er=>({...er,[app.id]:e.message}));
      showToast("Error: "+e.message, "error");
    }
    setDisbursing(d=>({...d,[app.id]:false}));
  };

  const retrySTK = async (app) => {
    if (!window.confirm(`Resend M-Pesa STK push to ${app.phone} for ${fmt(app.loanFeeAmount)}?`)) return;
    setRetrying(r=>({...r,[app.id]:true}));
    setErrors(e=>({...e,[app.id]:null}));
    try {
      const phone = (app.phone||"").startsWith("0") ? "254"+app.phone.substring(1) : app.phone;
      const r = await fetch(`${BASE}/loans/manual-stk`, {
        method:"POST",
        headers:{ Authorization:"Bearer "+tok(), "Content-Type":"application/json" },
        body: JSON.stringify({ phone, amount:app.loanFeeAmount, description:"Loan Processing Fee", reference:"APP-"+app.id })
      });
      const data = await r.json();
      if (r.ok && (data.ResponseCode === "0" || data.success !== false)) {
        showToast(`STK push resent to ${app.phone}! Ask them to enter PIN.`);
        // Update status back to PENDING_FEE
        await fetch(`${BASE}/loans/reset-payment/${app.id}`, { method:"PUT", headers:{ Authorization:"Bearer "+tok() } }).catch(()=>{});
        load();
      } else {
        const errMsg = data.message || data.errorMessage || data.errorCode || "STK push failed";
        setErrors(e=>({...e,[app.id]:errMsg}));
        showToast("STK failed: " + errMsg, "error");
      }
    } catch(e) {
      setErrors(er=>({...er,[app.id]:e.message}));
      showToast("Error: "+e.message, "error");
    }
    setRetrying(r=>({...r,[app.id]:false}));
  };

  const statuses = ["ALL","FEE_PAID","PENDING_FEE","PAYMENT_FAILED","DISBURSED"];
  const statusLabels = { ALL:"All", FEE_PAID:"Fee Paid", PENDING_FEE:"Pending Fee", PAYMENT_FAILED:"Payment Failed", DISBURSED:"Disbursed" };
  const statusColor = s => ({ PENDING_FEE:"#f59e0b", FEE_PAID:"#0066cc", DISBURSED:"#10b981", PAYMENT_FAILED:"#ef4444" }[s]||"#94a3b8");

  const filtered = loans.filter(l => {
    const matchFilter = filter === "ALL" || l.loanStatus === filter;
    const q = search.toLowerCase();
    const matchSearch = !q || (l.fullName||"").toLowerCase().includes(q) || (l.phone||"").includes(q) || (l.mpesaReceiptNumber||"").toLowerCase().includes(q) || (l.email||"").toLowerCase().includes(q);
    return matchFilter && matchSearch;
  });

  const feePaid = loans.filter(l => l.loanStatus === "FEE_PAID");
  const payFailed = loans.filter(l => l.loanStatus === "PAYMENT_FAILED");
  const totalFees = loans.filter(l => ["FEE_PAID","DISBURSED"].includes(l.loanStatus)).reduce((s,l)=>s+(l.loanFeeAmount||0),0);
  const totalDisbursed = loans.filter(l => l.loanStatus === "DISBURSED").reduce((s,l)=>s+(l.selectedLoanAmount||0),0);
  const pendingDisburse = feePaid.reduce((s,l)=>s+((l.selectedLoanAmount||0)-(l.loanFeeAmount||0)),0);

  return (
    <div style={{ fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" }}>

      {toast.msg && (
        <div style={{ position:"fixed", top:20, right:20, zIndex:9999, background:toast.type==="error"?"#ef4444":"#10b981", color:"white", padding:"13px 20px", borderRadius:10, fontSize:13, fontWeight:600, boxShadow:"0 4px 16px rgba(0,0,0,0.2)", maxWidth:380, display:"flex", alignItems:"center", gap:10 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
            {toast.type==="error" ? <><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></> : <polyline points="20 6 9 17 4 12"/>}
          </svg>
          {toast.msg}
        </div>
      )}

      {/* Stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))", gap:12, marginBottom:18 }}>
        {[
          ["Total Loans", loans.length, "#0066cc"],
          ["Fee Paid", feePaid.length+" applicants", "#0066cc"],
          ["Payment Failed", payFailed.length+" applicants", "#ef4444"],
          ["Fees Collected", fmt(totalFees), "#f59e0b"],
          ["Pending Disburse", fmt(pendingDisburse), "#7c3aed"],
          ["Disbursed", fmt(totalDisbursed), "#10b981"],
        ].map(([l,v,col])=>(
          <div key={l} style={{ background:"white", borderRadius:10, padding:"14px 16px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)", borderLeft:"4px solid "+col }}>
            <p style={{ fontSize:11, color:"#64748b", margin:"0 0 4px", fontWeight:600, textTransform:"uppercase", letterSpacing:.5 }}>{l}</p>
            <p style={{ fontSize:18, fontWeight:800, color:col, margin:0 }}>{v}</p>
          </div>
        ))}
      </div>

      {/* Alerts */}
      {feePaid.length > 0 && (
        <div style={{ background:"#eff6ff", border:"1.5px solid #bfdbfe", borderRadius:10, padding:"12px 16px", marginBottom:10, display:"flex", alignItems:"center", gap:10 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0066cc" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <p style={{ color:"#1e40af", fontSize:13, fontWeight:600, margin:0 }}>
            {feePaid.length} applicant{feePaid.length!==1?"s":""} paid fee � {fmt(pendingDisburse)} ready to disburse
          </p>
          <button onClick={()=>setFilter("FEE_PAID")} style={{ marginLeft:"auto", padding:"5px 12px", background:"#0066cc", color:"white", border:"none", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer" }}>View</button>
        </div>
      )}
      {payFailed.length > 0 && (
        <div style={{ background:"#fee2e2", border:"1.5px solid #fca5a5", borderRadius:10, padding:"12px 16px", marginBottom:10, display:"flex", alignItems:"center", gap:10 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <p style={{ color:"#7f1d1d", fontSize:13, fontWeight:600, margin:0 }}>
            {payFailed.length} applicant{payFailed.length!==1?"s":""} had payment failures � resend STK push to retry
          </p>
          <button onClick={()=>setFilter("PAYMENT_FAILED")} style={{ marginLeft:"auto", padding:"5px 12px", background:"#ef4444", color:"white", border:"none", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer" }}>View</button>
        </div>
      )}

      {/* Filter + Search */}
      <div style={{ background:"white", borderRadius:10, padding:"12px 14px", marginBottom:12, display:"flex", gap:6, flexWrap:"wrap", alignItems:"center", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
        {statuses.map(s=>(
          <button key={s} onClick={()=>setFilter(s)}
            style={{ padding:"6px 12px", borderRadius:20, border:"none", cursor:"pointer", fontSize:11, fontWeight:600, background:filter===s?statusColor(s):"#f1f5f9", color:filter===s?"white":"#64748b" }}>
            {statusLabels[s]} {s!=="ALL" && `(${loans.filter(l=>l.loanStatus===s).length})`}
          </button>
        ))}
        <div style={{ marginLeft:"auto", position:"relative" }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{ position:"absolute", left:8, top:"50%", transform:"translateY(-50%)" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, phone, receipt..."
            style={{ padding:"7px 10px 7px 26px", border:"1px solid #e2e8f0", borderRadius:7, fontSize:12, width:210 }}/>
        </div>
        <button onClick={load} style={{ padding:"7px 12px", borderRadius:7, border:"none", cursor:"pointer", fontSize:12, fontWeight:600, background:"#f1f5f9", color:"#64748b" }}>Refresh</button>
      </div>

      {/* Table */}
      <div style={{ background:"white", borderRadius:12, boxShadow:"0 1px 6px rgba(0,0,0,0.06)", overflow:"hidden" }}>
        <div style={{ padding:"12px 16px", borderBottom:"1px solid #f1f5f9", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <h3 style={{ fontSize:14, fontWeight:700, color:"#1e293b", margin:0 }}>
            {filter==="FEE_PAID"?"Applicants Who Paid Fee � Ready to Disburse":filter==="PAYMENT_FAILED"?"Failed Payments � Retry STK Push":filter==="DISBURSED"?"Disbursed Loans":"All Loans"}
          </h3>
          <span style={{ fontSize:12, color:"#94a3b8" }}>{filtered.length} records</span>
        </div>
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead>
              <tr style={{ background:"#f8fafc" }}>
                {["APP","Applicant","Phone","County","Loan Amount","Fee","M-Pesa Receipt","Txn ID","Status","Action"].map(h=>(
                  <th key={h} style={{ padding:"10px 12px", textAlign:"left", fontWeight:700, color:"#64748b", fontSize:10, textTransform:"uppercase", letterSpacing:.5, whiteSpace:"nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={10} style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>Loading...</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={10} style={{ padding:40, textAlign:"center", color:"#94a3b8" }}>No records found</td></tr>
              ) : filtered.map((l,i) => {
                const net = (l.selectedLoanAmount||0)-(l.loanFeeAmount||0);
                const isPaid = l.loanStatus==="FEE_PAID";
                const isFailed = l.loanStatus==="PAYMENT_FAILED";
                const errMsg = errors[l.id];
                return (
                  <>
                  <tr key={l.id} style={{ borderTop:"1px solid #f1f5f9", background:isPaid?"#f0f9ff":isFailed?"#fff5f5":i%2?"#fafafa":"white" }}>
                    <td style={{ padding:"11px 12px", color:"#0066cc", fontWeight:700 }}>APP-{l.id}</td>
                    <td style={{ padding:"11px 12px" }}>
                      <div style={{ fontWeight:600, color:"#1e293b" }}>{l.fullName}</div>
                      <div style={{ fontSize:11, color:"#94a3b8" }}>{l.email}</div>
                    </td>
                    <td style={{ padding:"11px 12px", fontFamily:"monospace", color:"#334155", whiteSpace:"nowrap" }}>{l.phone||"�"}</td>
                    <td style={{ padding:"11px 12px", color:"#64748b" }}>{l.county||"�"}</td>
                    <td style={{ padding:"11px 12px", fontWeight:700, color:"#0052a3" }}>{fmt(l.selectedLoanAmount)}</td>
                    <td style={{ padding:"11px 12px", fontWeight:700, color:"#10b981" }}>{l.loanFeeAmount?fmt(l.loanFeeAmount):"�"}</td>
                    <td style={{ padding:"11px 12px" }}>
                      {l.mpesaReceiptNumber ? (
                        <span style={{ background:"#f0fdf4", color:"#166534", borderRadius:5, padding:"3px 9px", fontSize:11, fontWeight:700, fontFamily:"monospace", whiteSpace:"nowrap" }}>
                          {l.mpesaReceiptNumber}
                        </span>
                      ) : <span style={{ color:"#94a3b8", fontSize:11 }}>No receipt yet</span>}
                    </td>
                    <td style={{ padding:"11px 12px", fontFamily:"monospace", fontSize:10, color:"#94a3b8", maxWidth:120, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {l.mpesaTransactionId ? l.mpesaTransactionId.substring(0,20)+"..." : "�"}
                    </td>
                    <td style={{ padding:"11px 12px" }}>
                      <span style={{ background:statusColor(l.loanStatus)+"20", color:statusColor(l.loanStatus), borderRadius:20, padding:"3px 10px", fontSize:10, fontWeight:700, whiteSpace:"nowrap" }}>
                        {(l.loanStatus||"NO LOAN").replace(/_/g," ")}
                      </span>
                    </td>
                    <td style={{ padding:"11px 12px" }}>
                      <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
                        {isPaid && (
                          <button onClick={()=>disburse(l)} disabled={disbursing[l.id]}
                            style={{ padding:"6px 12px", background:disbursing[l.id]?"#94a3b8":"linear-gradient(135deg,#10b981,#059669)", color:"white", border:"none", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                            {disbursing[l.id]?"Sending...":"Disburse "+fmt(net)}
                          </button>
                        )}
                        {isFailed && (
                          <button onClick={()=>retrySTK(l)} disabled={retrying[l.id]}
                            style={{ padding:"6px 12px", background:retrying[l.id]?"#94a3b8":"linear-gradient(135deg,#f59e0b,#d97706)", color:"white", border:"none", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                            {retrying[l.id]?"Sending STK...":"? Retry STK Push"}
                          </button>
                        )}
                        {l.loanStatus==="PENDING_FEE" && (
                          <button onClick={()=>retrySTK(l)} disabled={retrying[l.id]}
                            style={{ padding:"6px 12px", background:retrying[l.id]?"#94a3b8":"#0066cc", color:"white", border:"none", borderRadius:6, fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                            {retrying[l.id]?"Sending...":"Resend STK"}
                          </button>
                        )}
                        {l.loanStatus==="DISBURSED" && <span style={{ fontSize:12, color:"#10b981", fontWeight:700 }}>? Disbursed</span>}
                      </div>
                    </td>
                  </tr>
                  {errMsg && (
                    <tr key={l.id+"err"} style={{ background:"#fff5f5" }}>
                      <td colSpan={10} style={{ padding:"6px 12px 10px 50px" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                          <span style={{ fontSize:11, color:"#7f1d1d", fontWeight:600 }}>Error: {errMsg}</span>
                        </div>
                      </td>
                    </tr>
                  )}
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
